if (!customElements.get("m-countdown-timer")) {
  if (!customElements.get("m-countdown-timer")) {
    class MCountdownTimer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const time = this.dataset.time;
        let endTime = Date.parse(time.split(" ").join("T"));
        if (endTime) {
          let ms_12hours = 12 * 60 * 60 * 1000;
          let ms_2hours = 2 * 60 * 60 * 1000;
          let now = (new Date()).getTime();
          if(endTime - ms_2hours < Date.now()){
            if(endTime < Date.now()){
              let ms_past = (now - endTime) % ms_12hours;
              endTime = now - ms_past + ms_12hours;
              if(endTime - ms_2hours < Date.now()){
                endTime += ms_12hours - ms_2hours;
              }
            }else{
              let ms_past = endTime - now;
              endTime = now + ms_12hours - ms_2hours + ms_past;
            }
          }
          new CountdownTimer(this, Date.now(), endTime, {
            loop: true,
          });

          if (endTime > Date.now()) {
            this.classList.remove("hidden");
            this.classList.remove("m:hidden");
          }
        }
      }
    }

    customElements.define("m-countdown-timer", MCountdownTimer);
  }
}
